/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastTypeEnum } from './toastTypeEnum';
import { ToastButton } from './toastButton';


/**
 * Configuration for a toast notification.  Maps to WebSocketToastConfig in Angular.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface ToastConfig { 
    message: string;
    toastType?: ToastTypeEnum;
    headline?: string | null;
    duration?: number;
    closable?: boolean;
    buttons?: Array<ToastButton>;
}
export namespace ToastConfig {
}

export const ToastConfig_message_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ToastConfig_toastType_Validators: ValidatorFn[] =
    [ ];

export const ToastConfig_headline_Validators: ValidatorFn[] =
    [ ];

export const ToastConfig_duration_Validators: ValidatorFn[] =
    [ ];

export const ToastConfig_closable_Validators: ValidatorFn[] =
    [ ];

export const ToastConfig_buttons_Validators: ValidatorFn[] =
    [ ];


